// extracted by mini-css-extract-plugin
export default {"contentContainer":"HighConsumption_contentContainer__AZkmK","translation":"HighConsumption_translation__OcmXc","options":"HighConsumption_options__yMJ-j"};